var Backbone = require('backbone');
var _ = require('underscore');

var moment = require('moment');

require('./DateTimePicker.less');
require('datetimepicker/jquery.datetimepicker.js');
require('datetimepicker/jquery.datetimepicker.css');

module.exports = Backbone.View.extend({
    format: 'Y-m-d',

    value: false,

    initialize: function (options) {
        _.extend(this, options);
        _.bindAll(this, 'setDate', 'onClick');

        this.format = options.format || this.format;

        this.name = this.$el.attr('data-name');

        this.$day = this.$(".DateTimePicker-displayDay");
        this.$month = this.$(".DateTimePicker-displayMonth");
        this.$year = this.$(".DateTimePicker-displayYear");
        this.$time = this.$(".DateTimePicker-displayTime");
        this.step = options.step || 60;

        this.$value = this.$('.DateTimePicker-value');
        moment.locale('ru');

        this.$value.datetimepicker({
            format: this.format,
            timepicker: options.timepicker,
            onChangeDateTime: this.setDate,
            lang: 'ru',
            dayOfWeekStart: 1,
            step: this.step
        });

        this.$valueVisible = this.$('.DateTimePicker-valueVisible');

        this.$el.on('click', this.onClick);

        var date = this.$value.val() || false;
        date = !!date ? Date.parseDate(date, this.format) : new Date();

        this.setDate(date);
    },

    onClick: function () {
        this.$el.addClass('DateTimePicker--isActive');
        this.$value.datetimepicker('show');
    },

    setDate: function (dt) {
        var value = ''
        if (!dt) {
            return true;
        }

        this.value = dt;
        this.$value.datetimepicker('hide');

        value = moment(dt).format('ll');

        this.$valueVisible.html(value);

        this.$el.removeClass('DateTimePicker--isActive');

        this.trigger('change', dt);
    },

    setValue: function (date) {
        this.$value.val(moment(date).format('YYYY-MM-DD H:mm'));
        this.setDate(date);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/DateTimePicker/DateTimePicker.js
// module id = 172
// module chunks = 0